// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.full-width {
  width: 100%;
}

.form {
  min-width: 500px;
  width: 100%;
}

p {
  margin-bottom: 0rem;
}

.picker {
  position: absolute;
  z-index: 2;
}

.picker-overlay {
  background: transparent;
  left: 0;
  position: fixed;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: 1;
}


:host-context(.dark-theme) {
  .drop-above {
    border-top: 10px solid #555555;
  }
  
  .drop-below {
    border-bottom: 10px solid #555555;
  }
  
  .drop-center {
    background-color: #555555;
  }

  .mat-mdc-dialog-content,
  .mat-form-field,
  .mat-label,
  .mat-select-value-text,
  .mat-option-text,
  input,
  textarea,
  .mat-slide-toggle-content,
  .mat-checkbox-label,
  .mat-chip-row {
    color: black !important;
  }

  .mat-option {
    color: black !important;
    
    &:hover {
      background-color: rgba(0, 0, 0, 0.04) !important;
    }
  }

  .mat-icon {
    color: black !important;
  }

  .mat-chip-row {
    background-color: #e0e0e0 !important;
  }
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInRhZy1lZGl0LWRpYWxvZy5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxXQUFXO0FBQ2I7O0FBRUE7RUFDRSxnQkFBZ0I7RUFDaEIsV0FBVztBQUNiOztBQUVBO0VBQ0UsbUJBQW1CO0FBQ3JCOztBQUVBO0VBQ0Usa0JBQWtCO0VBQ2xCLFVBQVU7QUFDWjs7QUFFQTtFQUNFLHVCQUF1QjtFQUN2QixPQUFPO0VBQ1AsZUFBZTtFQUNmLE1BQU07RUFDTixZQUFZO0VBQ1osV0FBVztFQUNYLFVBQVU7QUFDWjs7O0FBR0E7RUFDRTtJQUNFLDhCQUE4QjtFQUNoQzs7RUFFQTtJQUNFLGlDQUFpQztFQUNuQzs7RUFFQTtJQUNFLHlCQUF5QjtFQUMzQjs7RUFFQTs7Ozs7Ozs7OztJQVVFLHVCQUF1QjtFQUN6Qjs7RUFFQTtJQUNFLHVCQUF1Qjs7SUFFdkI7TUFDRSxnREFBZ0Q7SUFDbEQ7RUFDRjs7RUFFQTtJQUNFLHVCQUF1QjtFQUN6Qjs7RUFFQTtJQUNFLG9DQUFvQztFQUN0QztBQUNGIiwiZmlsZSI6InRhZy1lZGl0LWRpYWxvZy5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuZnVsbC13aWR0aCB7XG4gIHdpZHRoOiAxMDAlO1xufVxuXG4uZm9ybSB7XG4gIG1pbi13aWR0aDogNTAwcHg7XG4gIHdpZHRoOiAxMDAlO1xufVxuXG5wIHtcbiAgbWFyZ2luLWJvdHRvbTogMHJlbTtcbn1cblxuLnBpY2tlciB7XG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgei1pbmRleDogMjtcbn1cblxuLnBpY2tlci1vdmVybGF5IHtcbiAgYmFja2dyb3VuZDogdHJhbnNwYXJlbnQ7XG4gIGxlZnQ6IDA7XG4gIHBvc2l0aW9uOiBmaXhlZDtcbiAgdG9wOiAwO1xuICBoZWlnaHQ6IDEwMCU7XG4gIHdpZHRoOiAxMDAlO1xuICB6LWluZGV4OiAxO1xufVxuXG5cbjpob3N0LWNvbnRleHQoLmRhcmstdGhlbWUpIHtcbiAgLmRyb3AtYWJvdmUge1xuICAgIGJvcmRlci10b3A6IDEwcHggc29saWQgIzU1NTU1NTtcbiAgfVxuICBcbiAgLmRyb3AtYmVsb3cge1xuICAgIGJvcmRlci1ib3R0b206IDEwcHggc29saWQgIzU1NTU1NTtcbiAgfVxuICBcbiAgLmRyb3AtY2VudGVyIHtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjNTU1NTU1O1xuICB9XG5cbiAgLm1hdC1tZGMtZGlhbG9nLWNvbnRlbnQsXG4gIC5tYXQtZm9ybS1maWVsZCxcbiAgLm1hdC1sYWJlbCxcbiAgLm1hdC1zZWxlY3QtdmFsdWUtdGV4dCxcbiAgLm1hdC1vcHRpb24tdGV4dCxcbiAgaW5wdXQsXG4gIHRleHRhcmVhLFxuICAubWF0LXNsaWRlLXRvZ2dsZS1jb250ZW50LFxuICAubWF0LWNoZWNrYm94LWxhYmVsLFxuICAubWF0LWNoaXAtcm93IHtcbiAgICBjb2xvcjogYmxhY2sgIWltcG9ydGFudDtcbiAgfVxuXG4gIC5tYXQtb3B0aW9uIHtcbiAgICBjb2xvcjogYmxhY2sgIWltcG9ydGFudDtcbiAgICBcbiAgICAmOmhvdmVyIHtcbiAgICAgIGJhY2tncm91bmQtY29sb3I6IHJnYmEoMCwgMCwgMCwgMC4wNCkgIWltcG9ydGFudDtcbiAgICB9XG4gIH1cblxuICAubWF0LWljb24ge1xuICAgIGNvbG9yOiBibGFjayAhaW1wb3J0YW50O1xuICB9XG5cbiAgLm1hdC1jaGlwLXJvdyB7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogI2UwZTBlMCAhaW1wb3J0YW50O1xuICB9XG59Il19 */`, "",{"version":3,"sources":["webpack://./src/app/components/tags/tag-edit-tree/tag-edit-dialog.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,OAAO;EACP,eAAe;EACf,MAAM;EACN,YAAY;EACZ,WAAW;EACX,UAAU;AACZ;;;AAGA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;;;;;;;;;IAUE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;;IAEvB;MACE,gDAAgD;IAClD;EACF;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,oCAAoC;EACtC;AACF;AACA,gmEAAgmE","sourcesContent":[".full-width {\n  width: 100%;\n}\n\n.form {\n  min-width: 500px;\n  width: 100%;\n}\n\np {\n  margin-bottom: 0rem;\n}\n\n.picker {\n  position: absolute;\n  z-index: 2;\n}\n\n.picker-overlay {\n  background: transparent;\n  left: 0;\n  position: fixed;\n  top: 0;\n  height: 100%;\n  width: 100%;\n  z-index: 1;\n}\n\n\n:host-context(.dark-theme) {\n  .drop-above {\n    border-top: 10px solid #555555;\n  }\n  \n  .drop-below {\n    border-bottom: 10px solid #555555;\n  }\n  \n  .drop-center {\n    background-color: #555555;\n  }\n\n  .mat-mdc-dialog-content,\n  .mat-form-field,\n  .mat-label,\n  .mat-select-value-text,\n  .mat-option-text,\n  input,\n  textarea,\n  .mat-slide-toggle-content,\n  .mat-checkbox-label,\n  .mat-chip-row {\n    color: black !important;\n  }\n\n  .mat-option {\n    color: black !important;\n    \n    &:hover {\n      background-color: rgba(0, 0, 0, 0.04) !important;\n    }\n  }\n\n  .mat-icon {\n    color: black !important;\n  }\n\n  .mat-chip-row {\n    background-color: #e0e0e0 !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
